import React from 'react';

interface Props {
    size?: 'L' | 'S'
}
const HeaderLogo: React.FC<Props> = ({ size = 'L' }) => {
    return (
        <div className="logo-text d-flex align-items-center">
            <div className="header-logo-container p-2 rounded d-flex align-items-center" 
                style={{ 
                    background: 'linear-gradient(to right, rgba(31, 136, 214, 0.05), rgba(32, 44, 75, 0.05))',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)';
                }}
            >{ size === 'L' ?
                <>
                    <span className="text-primary fw-bold fs-16" 
                        style={{ 
                            letterSpacing: '0.5px',
                            textShadow: '0px 0px 1px rgba(31, 136, 214, 0.2)'
                        }}
                    >
                        Pathshala
                    </span>
                    <div className="mx-2" style={{ 
                        height: '18px', 
                        width: '2px', 
                        background: 'rgba(32, 44, 75, 0.2)',
                        borderRadius: '1px'
                    }}></div>
                    <span className="fs-16 fw-bold" 
                        style={{ 
                            color: "#202C4B",
                            letterSpacing: '0.5px',
                            textShadow: '0px 0px 1px rgba(32, 44, 75, 0.2)'
                        }}
                    >
                        Sanchalak
                        
                    </span>
                </>
                :
                <>
                    <span className="text-primary fw-bold fs-12" 
                        style={{ 
                            letterSpacing: '0.5px',
                            textShadow: '0px 0px 1px rgba(31, 136, 214, 0.2)'
                        }}
                    >
                        P
                    </span>
                    <div className="mx-2" style={{ 
                        height: '18px', 
                        width: '2px', 
                        background: 'rgba(32, 44, 75, 0.2)',
                        borderRadius: '1px'
                    }}></div>
                    <span className="fs-12 fw-bold" 
                        style={{ 
                            color: "#202C4B",
                            letterSpacing: '0.5px',
                            textShadow: '0px 0px 1px rgba(32, 44, 75, 0.2)'
                        }}
                    >
                        S
                        
                    </span>
                </>
}
            </div>
        </div>
    )
}

export default HeaderLogo;